'use strict'

module.exports = function clone (el) {
  var clone = new el.constructor(el.name, el.attrs)
  for (var i = 0; i < el.children.length; i++) {
    var child = el.children[i]
    clone.cnode(child.clone ? child.clone() : child)
  }
  return clone
}



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/ltx/lib/clone.js
// module id = 377
// module chunks = 2